import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetSupportView = (params, setShowModal) => {
    return async (dispatch, getState) => {
        try {

            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_VIEW_SUPPORT
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetSupportViewAction(data.data));
            }

            setShowModal(true);

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetSupportView as SetGetSupportView
}